/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Tracking_Bulkclosedeal_Modaltitle4Inputs */

const en_coinvestments_tracking_bulkclosedeal_modaltitle4 = /** @type {(inputs: Coinvestments_Tracking_Bulkclosedeal_Modaltitle4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Opportunities`)
};

/**
* | output |
* | --- |
* | "Close Opportunities" |
*
* @param {Coinvestments_Tracking_Bulkclosedeal_Modaltitle4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_bulkclosedeal_modaltitle4 = /** @type {((inputs?: Coinvestments_Tracking_Bulkclosedeal_Modaltitle4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Bulkclosedeal_Modaltitle4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_bulkclosedeal_modaltitle4(inputs)
});
export { coinvestments_tracking_bulkclosedeal_modaltitle4 as "coInvestments_tracking_bulkCloseDeal_modalTitle" }